/* eslint-disable react/jsx-key */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useApi } from '../../../hooks/userApi';
import { CadastroProps } from '../../../types/cadastro';
import {
  ContainerColumn,
  Containerdiv,
  ContDiv,
  InputContainer,
  SelectContainer,
  Title,
} from './tableSecondaryCadastro-style';

const api = useApi();

const TableSecondaryCadastro: React.FC<CadastroProps> = ({ cadastro, title, select }) => {
  const [routes, setRoutes] = useState('');

  const [vendedores, setVendedores] = useState([]);
  const [cor, setCor] = useState([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const permissao = ['Vendedor', 'Admin'];

  useEffect(() => {
    if (window.location.pathname.split('/')[2] === 'clientes') setRoutes('clientes');
    else if (window.location.pathname.split('/')[2] === 'produtos') setRoutes('produtos');
    else if (window.location.pathname.split('/')[2] === 'vendedores') setRoutes('vendedores');
    const Load = async () => {
      await api
        .get('/vendedor')
        .then((response) => setVendedores(response.results))
        .catch((err) => {
          console.error('ops! ocorreu um erro' + err);
        });
    };

    const LoadCor = async () => {
      await api
        .get('/cor')
        .then((response) => setCor(response))
        .catch((err) => {
          console.error('ops! ocorreu um erro' + err);
        });
    };

    if (routes === 'clientes') Load();
    if (routes === 'produtos') LoadCor();
  }, [routes]);

  useEffect(() => {
    setVendedores(vendedores);
  }, [vendedores]);

  useEffect(() => {
    setCor(cor);
  }, [cor]);

  return (
    <Containerdiv>
      <Title primary>{title}</Title>
      {cadastro.map((cad) => (
        <ContDiv key={cad.id}>
          <ContainerColumn primary>
            <Title>{cad.title}</Title>
            {cad.id === 'arrCaracteristica' &&
              cad.content.map((caracteristica) => (
                // <div key={caracteristica.id}>ok</div>
                <Title>{caracteristica.title}</Title>
              ))}
          </ContainerColumn>
          <ContainerColumn secondary>
            {cad.type === 'select' && (
              <SelectContainer name={cad.title} id={String(cad.id)}>
                <option disabled selected>
                  Selecione
                </option>
                {routes === 'clientes' &&
                  vendedores &&
                  Array.isArray(vendedores) &&
                  vendedores.length > 0 &&
                  vendedores.map((vendedor) => (
                    <option key={vendedor.id} value={vendedor.id}>
                      {vendedor.nome}
                    </option>
                  ))}

                {
                  routes === 'produtos' &&
                    select.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.nome}
                      </option>
                    ))
                  // <option value="" >Escolha</option>
                }

                {
                  routes === 'vendedores' &&
                    permissao.map((valor, index) => (
                      <option key={index} value={valor}>
                        {valor}
                      </option>
                    ))
                  // <option value="" >Escolha</option>
                }
                {/* <option value="" selected disabled>Escolha uma categoria</option>
                  <option value="cad.title">{cad.title}</option> */}
              </SelectContainer>
            )}
            {cad.type !== 'select' && cad.id !== 'arrCaracteristica' && (
              <InputContainer type={cad.type} id={String(cad.id)} placeholder={cad.placeholder} />
            )}
            {cad.id === 'arrCaracteristica' &&
              cad.content.map((caracteristica) =>
                caracteristica.type !== 'select' ? (
                  // <div key={caracteristica.id}>ok</div>
                  <InputContainer
                    key={caracteristica.id}
                    type={caracteristica.type}
                    id={String(caracteristica.id)}
                    placeholder={caracteristica.placeholder}
                  />
                ) : (
                  <SelectContainer
                    key={caracteristica.id}
                    name={caracteristica.title}
                    id={String(caracteristica.id)}
                    // multiple
                  >
                    <option disabled selected>
                      Selecione
                    </option>
                    {routes === 'produtos' &&
                      cor.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.nome}
                        </option>
                      ))}
                  </SelectContainer>
                ),
              )}
          </ContainerColumn>
        </ContDiv>
      ))}
    </Containerdiv>
  );
};
export default TableSecondaryCadastro;
